/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAvatarCircleOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M15.242 12.261A3.89 3.89 0 0 0 16 9.947C16 7.751 14.192 6 12 6a4.02 4.02 0 0 0-2.301.719l1.46 1.46C11.415 8.064 11.7 8 12 8c1.121 0 2 .888 2 1.947a1.9 1.9 0 0 1-.208.865z" />
        <path d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm10-8a7.965 7.965 0 0 0-4.831 1.623L18.377 16.83A8 8 0 0 0 12 4zm-8 8a7.97 7.97 0 0 0 1.942 5.226 5.012 5.012 0 0 1 1.515-1.351c1.151-.68 2.668-1.033 4.543-1.033.59 0 1.145.035 1.664.104l-1.092-1.092c-.187.027-.378.04-.572.04-2.192 0-4-1.75-4-3.947 0-.21.016-.416.048-.616l-2.31-2.31A7.966 7.966 0 0 0 4 12zm3.442 6.575C8.735 19.474 10.306 20 12 20s3.265-.526 4.558-1.425a2.945 2.945 0 0 0-1.031-.978c-.752-.443-1.886-.755-3.527-.755-1.64 0-2.775.312-3.527.755a2.945 2.945 0 0 0-1.03.978z" />
      </g>
    </g>
  </Icon>
);
export { SvgAvatarCircleOff as AvatarCircleOff };
